import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useFormatting } from "../formatting/useFormatting.js";
import { FormattedInput } from "./FormattedInput.js";
export const FormattedFloatInput = ({ value, unit, min, max, step, multiplier = 1, onChange, ...props }) => {
    const { getFormattedFloat, getEditableFloat, getFloat } = useFormatting();
    function getFormattedValue(value) {
        if (value === null || value === undefined)
            return "";
        return getFormattedUnit(getFormattedFloat((value ?? 0) * multiplier, step), unit);
    }
    function getEditableValue(value) {
        if (value === null || value === undefined)
            return "";
        return getEditableFloat(value * multiplier, false, step);
    }
    const getActualValue = React.useCallback((value) => {
        if (value === null || value === "")
            return null;
        let float = getFloat(value, false);
        if (step)
            float = Math.round(float / step) * step;
        validate(float, min, max);
        return float / multiplier;
    }, [getFloat, max, min, multiplier]);
    return (_jsx(FormattedInput, { ...props, value: value, getFormattedValue: getFormattedValue, getActualValue: getActualValue, getEditableValue: getEditableValue, onChange: onChange }));
};
function validate(value, min, max) {
    if (Number.isNaN(value))
        throw new Error("Invalid value"); // TODO: translate
    if (min !== undefined && value < min)
        throw new Error("Value is < min allowed"); // TODO: translate
    if (max !== undefined && value > max)
        throw new Error("Value is > max allowed"); // TODO: translate
}
function getFormattedUnit(value, unit) {
    return `${value}${unit ?? ""}`.trim();
}
//# sourceMappingURL=FormattedFloatInput.js.map